import Phaser from 'phaser';
import { skillById } from './professions';

export function classSkillFx(scene:Phaser.Scene,id:string,x:number,y:number,facing:number,targetX=x+facing*120):void {
 const skill=skillById(id);if(!skill)return;
 const color=skill.classId==='sword-soldier'?0xff795c:skill.classId==='spear-soldier'?0xffcd70:skill.classId==='forest-hunter'?0x91db84:0xb69aff;
 const fx=scene.add.graphics().setDepth(80);fx.lineStyle(3,color,.95);
 if(skill.effect==='guard'||skill.effect==='summon'){
  fx.strokeCircle(x,y-45,38).lineStyle(1,0xffe4ae,.8).strokeCircle(x,y-45,30);
  for(let i=0;i<8;i++){const a=i*Math.PI/4;fx.lineBetween(x+Math.cos(a)*30,y-45+Math.sin(a)*30,x+Math.cos(a)*42,y-45+Math.sin(a)*42);}
 }else if(skill.effect==='trap'||skill.effect==='seal'){
  fx.strokeEllipse(targetX,y-4,74,24).lineBetween(targetX-28,y-55,targetX+28,y).lineBetween(targetX+28,y-55,targetX-28,y);
 }else if(skill.effect==='rain'||skill.effect==='ultimate'){
  for(let i=0;i<12;i++){const end=targetX+(i-6)*12;fx.lineBetween(end-facing*35,y-125-(i%3)*18,end,y-8);fx.fillStyle(color,.5).fillCircle(end,y-8,4);}
  fx.lineStyle(4,color,.85).strokeEllipse(targetX,y-5,140,40);
 }else if(skill.classId==='forest-hunter'||skill.classId==='shaman'){
  fx.lineBetween(x,y-40,targetX,y-38).fillStyle(color,1).fillTriangle(targetX,y-38,targetX-facing*12,y-45,targetX-facing*12,y-31);
 }else if(skill.classId==='spear-soldier'){
  fx.lineBetween(x,y-35,targetX,y-35).fillStyle(color,1).fillTriangle(targetX,y-35,targetX-facing*20,y-44,targetX-facing*20,y-26);
  if(skill.effect==='sweep')fx.strokeEllipse(targetX,y-35,110,46);
 }else{
  fx.beginPath().arc(x+facing*40,y-40,42,-1.6,.9).strokePath();
  fx.lineStyle(2,0xffe3c0,.85).beginPath().arc(x+facing*44,y-38,35,-1.6,.9).strokePath();
 }
 scene.tweens.add({targets:fx,alpha:0,duration:skill.effect==='ultimate'?900:skill.effect==='guard'?1100:500,onComplete:()=>fx.destroy()});
}
